import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
const paths = {
    add: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    save: "M17 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zM12 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5-7h8v5H7V5z",
    edit: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
    delete: "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z",
    refresh: "M17.65 6.35A8 8 0 1 0 20 12h-2a6 6 0 1 1-1.76-4.24L13 11h7V4l-2.35 2.35z",
    export: "M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
    import: "M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
    search: "M15.5 14h-.79l-.28-.27A6.5 6.5 0 1 0 14 15.5l.27.28v.79L19.5 22 22 19.5 16.5 14h-1zM10 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
    filter: "M3 5h18l-7 8v6l-4 2v-8L3 5z",
    approve: "M9 16.17 4.83 12l-1.41 1.41L9 19 21 7l-1.41-1.41L9 16.17z",
    reject: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z",
    cancel: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
    close: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z",
    back: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    next: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z",
    view: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    print: "M18 7H6V3h12v4zm1 1H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-6h8v6zm3-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    download: "M19 18H5v2h14v-2zM13 3h-2v9H7l5 5 5-5h-4V3z",
    upload: "M19 18H5v2h14v-2zM11 17h2V8h4l-5-5-5 5h4v9z",
    publish: "M5 20h14v-2H5v2zM11 17h2V8h4l-5-5-5 5h4v9z",
    archive: "M20 3H4c-1.1 0-2 .9-2 2v3c0 .73.4 1.37 1 1.72V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.72c.6-.35 1-.99 1-1.72V5c0-1.1-.9-2-2-2zm-1 16H5V10h14v9zm1-11H4V5h16v3zm-11 4h6v2H9v-2z",
    reset: "M12 4V1L8 5l4 4V6a6 6 0 1 1-6 6H4a8 8 0 1 0 8-8z",
    info: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
    expand: "M4 4h7v2H7.41l4.3 4.29-1.42 1.42L6 7.41V11H4V4zm16 16h-7v-2h3.59l-4.3-4.29 1.42-1.42L18 16.59V13h2v7z",
    shrink: "M11 11H4V9h3.59L3.3 4.71l1.42-1.42L9 7.59V4h2v7zm2 2h7v2h-3.59l4.3 4.29-1.42 1.42L15 16.41V20h-2v-7z",
    copy: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
    table: "M3 3h18v18H3V3zm2 2v4h14V5H5zm0 6v4h6v-4H5zm8 0v4h6v-4h-6zM5 17v2h6v-2H5zm8 0v2h6v-2h-6z",
};
export const resolveActionIcon = (actionIdOrLabel) => {
    const key = actionIdOrLabel.toLowerCase().replace(/([a-z])([A-Z])/g, "$1-$2");
    const words = key.split(/[^a-z]+/).filter(Boolean);
    const aliases = {
        create: "add", new: "add", remove: "delete", clear: "delete",
        update: "save", submit: "save", reload: "refresh",
        apply: "approve", confirm: "approve", discard: "cancel",
        previous: "back", details: "view", open: "view",
        restore: "reset", undo: "reset",
    };
    for (const word of words) {
        if (word in paths)
            return word;
        if (word in aliases)
            return aliases[word];
    }
    return undefined;
};
export const ActionIcon = ({ name }) => (_jsx(SvgIcon, { "aria-hidden": "true", fontSize: "small", viewBox: "0 0 24 24", children: _jsx("path", { d: paths[name] }) }));
//# sourceMappingURL=action-icons.js.map